import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { CloseAllGaps, translateRxOption } from "~/common/prescription";
import { Label } from "~/components/ui/label";
import type { TPrescription } from "~/types/prescription";

import { PatientCardTeethItems } from "./patient-card-teeth-items";

export function PatientCardCloseAllGaps({ prescription: { close_all_gaps, close_all_gaps_value, close_all_gaps_spaces } }: { prescription: TPrescription }) {
  const intl = useIntl();
  const leaveSpaceEntries = Object.entries(close_all_gaps_spaces ?? {});

  return (
    <div>
      <Label id="close-all-gaps-label" readOnly>
        <FormattedMessage id="HEADER_CLOSE_ALL" />
      </Label>

      {/* Match `LabelledValue` field spacing and typography. */}
      <div className="tw-mb-5" id="close-all-gaps-value">
        <p className="tw-mb-[5px] tw-text-sm tw-font-semibold tw-leading-5">
          <FormattedMessage id={translateRxOption("close_all_gaps", close_all_gaps)} />
        </p>

        {close_all_gaps == CloseAllGaps.LEAVE_SPACE ? (
          <>
            {close_all_gaps_value ? (
              <p className="tw-mb-4 tw-ml-7 tw-whitespace-pre-line tw-italic" style={{ wordBreak: "break-word" }}>
                {close_all_gaps_value}
              </p>
            ) : null}

            {leaveSpaceEntries.length > 0 ? (
              <div>
                {/* Teeth to leave space for — the FDI checkbox chart the frame shows (PV4), reusing the
                    shared teeth-grid primitive; the mm values are kept below so no data is dropped. */}
                <PatientCardTeethItems label="CAG_LEAVE_SPACE_FOR" defaultValue={leaveSpaceEntries.map(([key]) => Number(key))} />
                <div className="tw-ml-1 tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-1 tw-text-sm">
                  {leaveSpaceEntries.map(([key, value]) => {
                    const toothText = intl.formatMessage({ id: "TOOTH_NUMBER" });
                    const tooth = Number(key);
                    const mmText = intl.formatMessage({ id: "MILLIMETRES" });
                    return <span key={key}>{`${toothText} ${tooth} - ${value} ${mmText}`}</span>;
                  })}
                </div>
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
}
